export enum EUserRole {
  ADMIN = 'ADMIN', // 1 - level
  EXPERT = 'EXPERT', // 2 -level
  SPECIALIST = 'SPECIALIST', // 3 - level
  OPERATOR = 'OPERATOR' // 4 - level
}
